import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import DefaultLayout from "../../layouts/DefaultLayout";
import { withRouter } from "react-router-dom";
import { Upload, Button, Card, Col, Input, Row, Table, message, DatePicker } from "antd";
import { debounce } from "lodash";
import { RULES_FILE_UPLOAD } from "../../../configs/api-paths";
import SelectInsurer from "./SelectInsurer";

/**
 * Shows insurance rate files.
 */
@inject("context")
@withRouter
@observer
class Rates extends Component {
	state = {
		selectedInsurerId: null,
		activeFrom: null,
	};

	onChangeSelectedInsurerId(newInsurerId) {
		this.setState({
			selectedInsurerId: newInsurerId,
		});
	}

	componentDidMount() {
		this.reloadRateFiles();
	}

	handleDateChange(date, dateString) {
		this.setState({
			activeFrom: dateString,
		});
	}
	
	render() {
		const service = this.props.context.rateFilesService;
		
		const columns = [
			{
				title: "Uploaded At",
				dataIndex: "uploadedAt",
				sorter: true,
				defaultSortOrder: "descend",
				render: (date) => {
					return new Date(date).toLocaleDateString();
				},
			},
			{
				title: "File Name",
				dataIndex: "name",
				sorter: true,
			},
			{
				title: "Insurer",
				dataIndex: ["insurer", "name"],
			},
			{
				title: "Actions",
				render: (field, record) => {
					return (
						<>
							<Button
								type="primary"
								onClick={() => this.handleValidateButtonClick(record)}
							>
								Validate
							</Button>
							<Button
								type="danger"
								onClick={() => this.handleDeleteButtonClick(record)}
							>
								Delete
							</Button>
						</>
					);
				},
			},
		];

		const { username } = this.props.context.applicationService.userProfile;
		const BASE_API_URL = process.env.INSURFORCE_BASE_API_URL;
		const uploadAccepts = `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel`;
		return (
			<DefaultLayout
				layoutContentProps={{
					style: {
						maxWidth: "100%",
						paddingLeft: 40,
						paddingRight: 40,
					},
				}}
			>
				<Row>
					<Col xs={24}>
						<Card title={<h1>Manage Rates</h1>}>
							<Row>
								<Col
									xs={6}
									style={{
										paddingBottom: "15px",
									}}
								>
									<Input.Search
										onSearch={this.handleSearchChange}
										onChange={this.handleSearchChange}
										value={service.search}
									/>
								</Col>
								<Col
									xs={6}
									style={{
										paddingBottom: "15px",
										paddingLeft: "15px",
									}}
								>
									<Button onClick={() => this.handleActiveRatesButtonClick()}>
										Active Rates
									</Button>
								</Col>
							</Row>
							<Row>
								<Col xs={24}>
									<Table
										rowKey="id"
										columns={columns}
										dataSource={service.rateFilesData}
										pagination={service.pagination}
										loading={service.loading}
										onChange={this.handleTableChange}
									/>
								</Col>
							</Row>
							<Row>
								<Col>
									<DatePicker format="DD-MM-YYYY" onChange={this.handleDateChange.bind(this)} />
								</Col>
								<Col
									style={{
										margin:'0rem 0.3rem 0.3rem 0.3rem'
									}}
								>
									<SelectInsurer
										onChangeSelected={this.onChangeSelectedInsurerId.bind(this)}
									/>
								</Col>
								<Col>
									<Upload
										action={BASE_API_URL + RULES_FILE_UPLOAD}
										accept={uploadAccepts}
										data={{
											insurerId: this.state.selectedInsurerId,
											uploadedBy: username,
											activeFrom: this.state.activeFrom,
										}}
										onChange={this.handleUploadChange.bind(this)}
									>
										<Button disabled={!(this.state.selectedInsurerId && this.state.activeFrom)}>
											Upload a new rate file
										</Button>
									</Upload>
								</Col>
							</Row>
						</Card>
					</Col>
				</Row>
			</DefaultLayout>
		);
	}

	handleTableChange = (pagination, filters, sorter) => {
		const service = this.props.context.rateFilesService;

		service.setPagination(pagination);
		service.setSorter(sorter);

		service.loadRateFilesData();
	};

	handleSearchChange = (...args) => {
		const value =
			args.length === 2
				? args[1].currentTarget.value
				: args[0].currentTarget.value;
		this.props.context.rateFilesService.setSearch(value);

		this.debouncedReloadItems();
	};

	handleValidateButtonClick = async (record) => {
		const { name } = record;

		if (name) {
			const { insuranceRateQuotingService } = this.props.context;
			insuranceRateQuotingService.setRateFileSelected(record);
			this.props.history.push(`/rates/${name}`);
		}
	};

	handleDeleteButtonClick = async (record) => {
		const { applicationService, rateFilesService } = this.props.context;
		const { username } = applicationService.userProfile;
		const { id, name } = record;

		if (id) {
			const deleted = await rateFilesService.deleteRateFile(id, name, username);
			if (deleted) await this.reloadRateFiles();
		}
	};

	reloadRateFiles = async () => {
		await this.props.context.rateFilesService.loadRateFilesValidationData();
	};

	debouncedReloadItems = debounce(this.reloadRateFiles, 250);

	handleUploadChange(info) {
		if (info.file.status === "done") {
			message.success(`${info.file.name} file uploaded successfully`, 5);
			this.reloadRateFiles();
		} else if (info.file.status === "error") {
			message.error(
				`${info.file.name} file upload failed. Error: ${info.file.response.message}`,
				10
			);
		}
	}

	handleActiveRatesButtonClick() {
		this.props.history.push("/rates/active");
	}
}

export default Rates;
